// Copyright (c) Docugami, Inc. All rights reserved.

import { useEffect } from "react";

export function useWaitCursor(isWaiting: boolean) {
    useEffect(() => () => { document.body.style.cursor = "auto" }, [])

    useEffect(() => {
        if (isWaiting) {
            document.body.style.cursor = "wait";
        }

        return () => {
            document.body.style.cursor = "auto";
        }
    }, [isWaiting])
}
